import createVueApp from '@phoenix/createVueApp';
import SignUpForm from '@maison/components/form/myAccount/SignUpForm.vue';

const app = createVueApp({}, true);
app.component('SignUpForm', SignUpForm);
app.mount('#phoenix-my-account-sign-up-form');
